export default {
  ENTER_KEYCODE: 13,
  ARROW_UP_KEYCODE: 38,
  ARROW_DOWN_KEYCODE: 40,
  ARROW_LEFT_KEYCODE: 37,
  ARROW_RIGHT_KEYCODE: 39,
  BACKSPACE_KEYCODE: 8,
  DELETE_KEYCODE: 46,
  TAB_KEYCODE: 9,
  RIGHT_CLICK_TRIGGER_ID: 'right-click',

  DIALOG_APPEARANCE: 'dialog',
  DIALOG_BLOCK_APPEARANCE: 'dialog-block',
  APP_ELEMENT_SELECTOR: '#app',
};
